/**
 * @flow
 * @relayHash 3fbf31f704819fe24a660661370273da
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SystemDocumentTemplateFromDocumentInput = {
  documentPk: number,
  clientMutationId?: ?string,
};
export type ConvertDocumentToSystemTemplateMutationVariables = {|
  input: SystemDocumentTemplateFromDocumentInput
|};
export type ConvertDocumentToSystemTemplateMutationResponse = {|
  +systemDocumentTemplateFromDocument: ?{|
    +ok: ?boolean,
    +systemDocumentTemplateId: ?number,
    +redirectUrl: ?string,
    +error: ?any,
  |}
|};
export type ConvertDocumentToSystemTemplateMutation = {|
  variables: ConvertDocumentToSystemTemplateMutationVariables,
  response: ConvertDocumentToSystemTemplateMutationResponse,
|};
*/


/*
mutation ConvertDocumentToSystemTemplateMutation(
  $input: SystemDocumentTemplateFromDocumentInput!
) {
  systemDocumentTemplateFromDocument(input: $input) {
    ok
    systemDocumentTemplateId
    redirectUrl
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SystemDocumentTemplateFromDocumentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "systemDocumentTemplateFromDocument",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SystemDocumentTemplateFromDocumentInput!"
      }
    ],
    "concreteType": "SystemDocumentTemplateFromDocumentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "systemDocumentTemplateId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "redirectUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ConvertDocumentToSystemTemplateMutation",
  "id": "3131f3695890ad008540cff7093644b8",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ConvertDocumentToSystemTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ConvertDocumentToSystemTemplateMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation ConvertDocumentToSystemTemplateMutation(\n  $input: SystemDocumentTemplateFromDocumentInput!\n) {\n  systemDocumentTemplateFromDocument(input: $input) {\n    ok\n    systemDocumentTemplateId\n    redirectUrl\n    error\n  }\n}\n";
(node/*: any*/).hash = '5b9ff44ef67c4ca380c6d17eb453569f';
module.exports = node;
